import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicantService } from '../../_services/applicant.service';
import { ApplicantHistoryItem } from '../../_models/applicant-history-item'
import { AuthenticationService } from '../../_services/authentication.service';
import { Grant } from '../../_models/grant';
import { GrantFile } from '../../_models/grantFile';
import { GrantService } from '../../_services/grant.service';

@Component({
  moduleId: module.id,
  selector: 'cover',
  templateUrl: 'cover.component.html',
  styleUrls: ['cover.component.css']
})

export class CoverComponent implements OnInit {
  files: GrantFile[];
  applicantHistory: ApplicantHistoryItem[];

  @Input() newFiles: FileList;
  @Input() grant: Grant;

  @Output() newFilesChange = new EventEmitter();

  constructor(
    private applicantService: ApplicantService,
    private authenticationService: AuthenticationService,
    private grantService: GrantService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.listFiles(params['id']);
      }
    });
    this.applicantHistory = [];
  }


  listApplicantHistory(applicantkey: string) {
    //console.log("calling getApplicantHistory");
    this.applicantService.getApplicantHistory(applicantkey)
      .then(history => {
        this.applicantHistory = history.sort((aDate, bDate) =>{
          //Null dates haven't happened yet so they are after any date that is defined
          if (!aDate.createdate) return -1;
          if (!bDate.createdate) return 1;

          return aDate.createdate.localeCompare(bDate.createdate);
        }).filter(x => {
          var lastYear = new Date();
          lastYear.setMonth(lastYear.getMonth() - 12);

          return (new Date(x.createdate)) > lastYear;
        })
      });
  }

  deleteFile(fileId, grantId, index) {
    this.grantService.deleteFile(fileId, grantId)
      .then(resp => {
        if (resp.status === 200) {
          this.files.splice(index, 1);
        } else {
          // TODO: show error
        }
      });
  }

  listFiles(id: number) {
    this.grantService.getFiles(id)
      .then(files => {
        this.files = files;
      });
  }

  fileChange(event) {
    this.newFiles = event.target.files;
    this.newFilesChange.emit(this.newFiles);
  }
}




// WEBPACK FOOTER //
// ./src/app/grant-form/cover/cover.component.ts